/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  InputLabel,
  TextField,
} from '@mui/material';
import { CommonElementProps } from '../types';
import ElementUtils from '../utils';

export interface TextAreaProps extends CommonElementProps<string> {
  label?: string;
  value?: string;
  disabled?: boolean;
  rows?: number;
  onChange?: (value: string) => void;
  maxCharacterLimit?: number;
  handleCharacterCount?: (reasonLength: number) => void;
  characterCount?: boolean;
}

function TextArea(props: TextAreaProps) {
  const {
    label,
    value,
    disabled,
    rows,
    error,
    onChange,
    placeholder,
    maxCharacterLimit,
    handleCharacterCount,
    characterCount,
  } = props;

  const [currentCharCount, setCurrentCharCount] = useState<number>(value?.length || 0);

  const handleValueChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setCurrentCharCount(newValue.length);

    if (onChange) {
      onChange(newValue);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      setCurrentCharCount(value.length);

      if (maxCharacterLimit && handleCharacterCount) {
        handleCharacterCount(value.length);
      }
    }
  }, [value, maxCharacterLimit, handleCharacterCount]);

  return (
    <div className="flex flex-col relative justify-center items-start">
      {label && (
        <InputLabel className="font-bold text-[#28364C] text-[16px] leading-[23px]" error={!!error}>{label}</InputLabel>
      )}
      <TextField
        placeholder={placeholder || label}
        className="w-full "
        id="outlined-basic"
        InputProps={{
          inputProps: { maxLength: maxCharacterLimit, disabled },
          classes: {
            root: 'bg-white custom-shadow rouded-md mt-1',
            error: 'outline outline-[1px] outline-error',
          },
        }}
        sx={{
          '& fieldset': { border: 'none' },
          '.MuiInputBase-input': { fontWeight: '500' },
        }}
        color="primary"
        rows={rows}
        multiline
        value={value}
        defaultValue={value}
        variant="outlined"
        helperText={characterCount && maxCharacterLimit ? `${currentCharCount}/${maxCharacterLimit}` : ''}
        disabled={disabled}
        onChange={handleValueChange}
        error={Boolean(error)}
      />
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </div>
  );
}

TextArea.defaultProps = {
  label: '',
  value: '',
  rows: 1,
  disabled: false,
  onChange: () => { },
  maxCharacterLimit: undefined,
  handleCharacterCount: undefined,
  characterCount: false,
};

export default TextArea;
